import { DOM } from "./dom.js";
export const Classes = { dom: DOM };
